import React from 'react';

function Contact() {
  return (
    <>
      <div className="contactContainer">
        <div className="contact">
          <h2>お問い合わせ</h2>
          <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfoTjUeo6u5l5ainzO-R252Oz_t4oFky5Vpk4adwd8gVoeoJw/viewform?embedded=true" width="640" height="721" frameBorder="0" marginHeight="0" marginWidth="0">読み込んでいます…</iframe>
        </div>
      </div>
    </>
  )
}

export default Contact;